import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-white">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于91片，您想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="font-medium text-sm md:text-base text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <span className="flex-shrink-0 flex items-center justify-center w-6 h-6">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-foreground-500 text-lg transition-transform duration-200 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 py-4 bg-white border-t border-background-200">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}